<div class="fixedfilters">
    <div class="fidoli-software"
        *ngIf="!manufacturer?.toLowerCase().includes('schiller') && (schillerFilters?.lowFilter>0 || schillerFilters?.highFilter>0)">
        <mat-icon matTooltip="{{ 'FidoliSoftwareWarning' | translate }}">warning</mat-icon>
    </div>

    <div class="filter" *ngIf="notch && !!notch.value">
        <img src="assets/images/Notch.png" alt="Notch" />
        <label>{{notch.value}} Hz</label>
    </div>

    <div class="break"></div>

    <div class="filter" *ngIf="highPass && !!highPass.value">
        <img src="assets/images/HighPass.png" alt="High-Pass filter" />
        <label>{{highPass.value}} Hz</label>
    </div>

    <div class="break"></div>

    <div class="filter" *ngIf="lowPass && !!lowPass.value">
        <img src="assets/images/LowPass.png" alt="Low-Pass filter" />
        <label *ngIf="schillerFilters?.lowFilter>0">{{schillerFilters?.lowFilter}} Hz</label>
        <label *ngIf="schillerFilters?.lowFilter<=0">{{lowPass.value}} Hz</label>
    </div>

</div>
